import type { RootState } from '@/store';

export const selectActiveProducts = (state: RootState) => state.activeProducts.products;

export const selectActiveProductsLoading = (state: RootState) => state.activeProducts.loading;

export const selectActiveProductsError = (state: RootState) => state.activeProducts.error;
